import React from 'react';
import defaultUser from '../../assets/default-user.png';

const Memberships = ({organizer, baseURL}) => {
  return (
    <section className="company-third">
      <div className="container">
        <table className="table-borderless w-100 mb-5">
          <tr>
            <td>
              <p className="mb-0" style={{fontSize: '14px', fontWeight: '600'}}>Anggota dan Pengurus</p>
            </td>
            <td className="tb" style={{width: '80%'}}>
              <div className="d-lg-block d-md-block d-sm-none d-none" style={{borderTop: '1px solid rgba(49, 49, 49, 0.12)', width: '100%'}}></div>
            </td>
          </tr>
        </table>
        <div className="row">
          {organizer.memberships ? organizer.memberships.map(e => (
            <div className="col-lg-4 col-md-4 col-sm-12 col-12 mb-5">
            <table className="table-borderless">
              <tr>
                <td>
                  <img className="mr-4" src={e.picture ? baseURL+'/'+e.picture : defaultUser} alt={e._id} style={{width: '80px', height: '80px', borderRadius: '50%', objectFit: 'contain'}} />
                </td>
                <td>
                  <p style={{fontSize: '15px', fontWeight: '600'}}>{e.name}</p>
                  <p style={{fontSize: '12px'}}>{e.position}</p>
                </td>
              </tr>
            </table>
          </div>
          )) : null}
        </div>
      </div>
    </section>
  )
}

export default Memberships